import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ShieldCheck } from 'lucide-react'

const CONSENT_KEY = 'aqua_datos_consent'
const CONSENT_VERSION = '2025-06'

// Aviso informativo de la Ley 1581. No bloquea la página: la autorización
// expresa se pide con una casilla al crear la cuenta, que es cuando de verdad
// se recogen datos personales.
export default function ConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let stored: string | null = null
    try { stored = localStorage.getItem(CONSENT_KEY) } catch { /* modo privado */ }
    if (stored !== CONSENT_VERSION) {
      // Pequeño delay para que no compita con el primer paint
      const t = setTimeout(() => setVisible(true), 1200)
      return () => clearTimeout(t)
    }
  }, [])

  function cerrar() {
    try {
      localStorage.setItem(CONSENT_KEY, CONSENT_VERSION)
      localStorage.setItem('aqua_consent_ts', new Date().toISOString())
    } catch { /* modo privado */ }
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      role="region"
      aria-label="Aviso de tratamiento de datos"
      className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-md z-[9999]
                 bg-white/95 backdrop-blur border border-gray-200 rounded-2xl shadow-lg
                 px-4 py-3 flex items-start gap-3"
    >
      <ShieldCheck size={18} className="text-aqua-500 shrink-0 mt-0.5" />
      <p className="text-xs text-gray-600 leading-relaxed flex-1">
        Usamos tus datos solo para tu cuenta, tus pedidos y tus Aqua Puntos. Nunca los vendemos.{' '}
        <Link to="/privacidad" className="text-aqua-600 underline font-medium">Ver política</Link>
      </p>
      <button
        onClick={cerrar}
        className="text-xs font-bold text-aqua-600 hover:text-aqua-700 whitespace-nowrap self-center"
      >
        Entendido
      </button>
    </div>
  )
}
